import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=16309d22&scoped=true"
import script from "./AddCategory.vue?vue&type=script&lang=js"
export * from "./AddCategory.vue?vue&type=script&lang=js"
import style0 from "./AddCategory.vue?vue&type=style&index=0&id=16309d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16309d22",
  null
  
)

export default component.exports